import { render, staticRenderFns } from "./ItemTimedEvents.vue?vue&type=template&id=566fe943"
import script from "./ItemTimedEvents.vue?vue&type=script&lang=ts"
export * from "./ItemTimedEvents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports